import { Modal } from 'antd';
import React from 'react';
import style from './style.module.scss';
import {
  APPLICABLE_FOR_TYPE,
  CATEGORY_TYPES,
  DELIVERY_TYPE,
  offerType,
  offerTypeReverse,
  REQUIREMENT_TYPE,
} from '../base';
import DownloadImg from 'assets/download.svg';

const LabelValue = ({ label, value }) => (
  <div className={style['detail-row']}>
    <div className={style['detail-label']}>{label}</div>
    <div className={style['detail-value']}>{value || '-'}</div>
  </div>
);

const formatDateTime = (date) => {
  if (!date) return '-';
  const d = new Date(date);
  return (
    d.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }) +
    ' | ' +
    d.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
    })
  );
};

const CouponDetailsModal = ({ isModalOpen, setIsModalOpen, selectedRow }) => {
  return (
    <Modal
      open={isModalOpen}
      destroyOnClose
      width={600}
      footer={null}
      onCancel={() => setIsModalOpen(false)}
      title="Coupons details"
      className={style['coupon-details-modal']}>
      <div className={style['details-section']}>
        <h4 className={style['section-title']}>Order specifications</h4>

        <LabelValue
          label="Category"
          value={
            selectedRow?.categories && selectedRow?.categories.length
              ? selectedRow?.categories.map((val) => CATEGORY_TYPES[val]).join(', ')
              : '-'
          }
        />
        <LabelValue
          label="Requirement type"
          value={
            selectedRow?.requirementTypes && selectedRow?.requirementTypes.length
              ? selectedRow?.requirementTypes.map((val) => REQUIREMENT_TYPE[val]).join(', ')
              : '-'
          }
        />
        <LabelValue
          label="Applicable for"
          value={
            selectedRow?.applicableFor && selectedRow?.applicableFor.length
              ? selectedRow?.applicableFor.map((val) => APPLICABLE_FOR_TYPE[val]).join(', ')
              : '-'
          }
        />
        <LabelValue
          label="Delivery type"
          value={
            selectedRow?.deliveryTypes && selectedRow?.deliveryTypes.length
              ? selectedRow?.deliveryTypes.map((val) => DELIVERY_TYPE[val]).join(', ')
              : '-'
          }
        />
        <LabelValue label="Minimum quantity" value={`${selectedRow?.minQuantity || '-'} m`} />
        <LabelValue
          label="Minimum order value (Inclusive of taxes)"
          value={selectedRow?.minOrderValue ? `₹ ${selectedRow.minOrderValue}` : '-'}
        />
        <LabelValue
          label="Minimum order margin"
          value={selectedRow?.minMargin ? `${selectedRow.minMargin} %` : '-'}
        />

        <h4 className={style['section-title']}>Coupon specifications</h4>

        <LabelValue label="Coupon name" value={selectedRow?.couponName} />
        <LabelValue label="Coupon code" value={selectedRow?.couponCode} />
        <LabelValue label="Offer type" value={offerType[selectedRow?.offerType]} />
        <LabelValue label="Start Date and Time" value={formatDateTime(selectedRow?.startDate)} />
        <LabelValue label="End Date and Time" value={formatDateTime(selectedRow?.endDate)} />
        <LabelValue
          label={`Discount ${
            selectedRow?.offerType === offerTypeReverse.PERCENTAGE ? 'percentage' : 'amount'
          }`}
          value={(() => {
            switch (selectedRow?.offerType) {
              case offerTypeReverse.PERMETER:
                return `₹ ${selectedRow?.discountAmount} /m`;
              case offerTypeReverse.PERCENTAGE:
                return `${selectedRow?.discountPercentage} %`;
              case offerTypeReverse.ABSOLUTE:
                return `₹ ${selectedRow?.discountAmount}`;
              default:
                return '-';
            }
          })()}
        />
        {/* <LabelValue
          label={`Discount ${
            selectedRow?.offerType === offerTypeReverse.PERCENTAGE ? 'percentage' : 'amount'
          }`}
          value={
            selectedRow?.offerType === offerTypeReverse.PERCENTAGE
              ? `${selectedRow?.discountPercentage} %`
              : selectedRow?.offerType === offerTypeReverse.ABSOLUTE
              ? `₹ ${selectedRow.discountAmount}`
              : '-'
          }
        /> */}
        <LabelValue label="Max usage per user" value={selectedRow?.maxUsagePerUser} />
        <LabelValue
          label="Is this coupon for new customers?"
          value={selectedRow?.isForNewCustomers ? 'Yes' : 'No'}
        />
        <LabelValue
          label="Display this coupon to the customer?"
          value={selectedRow?.isVisible ? 'Yes' : 'No'}
        />

        <LabelValue
          label="Customer sheet"
          value={
            selectedRow?.customerSheet ? (
              <a
                href={selectedRow.customerSheet}
                target="_blank"
                rel="noopener noreferrer"
                className={style['download-btn']}>
                Customer_list
                <img src={DownloadImg} alt="download" className={style['download-logo']} />
              </a>
            ) : (
              '-'
            )
          }
        />
      </div>
    </Modal>
  );
};

export default CouponDetailsModal;
